"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
/**
 * Component for Metaform select field
 */
class MetaformSelectFieldComponent extends react_1.default.Component {
    /**
     * Constructor
     *
     * @param props component props
     */
    constructor(props) {
        super(props);
        /**
         * Event handler for field input change
         *
         * @param event event
         */
        this.onChange = (event) => {
            const selectedValue = event.target.value;
            if (event.target.value) {
                this.props.onValueChange(selectedValue);
            }
        };
        this.state = {};
    }
    /**
     * Component render method
     */
    render() {
        const { field, value, formReadOnly } = this.props;
        if (!field.name) {
            return null;
        }
        const options = field.options || [];
        const selected = value || (options.length > 0 ? options[0].name : "");
        const readOnly = formReadOnly || field.readonly;
        return (react_1.default.createElement("div", null,
            react_1.default.createElement("select", { onChange: this.onChange, value: selected, autoFocus: false, disabled: readOnly }, options.map((option) => react_1.default.createElement("option", { key: option.name, value: option.name }, option.text)))));
    }
}
exports.MetaformSelectFieldComponent = MetaformSelectFieldComponent;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTWV0YWZvcm1TZWxlY3RGaWVsZENvbXBvbmVudC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3NyYy9NZXRhZm9ybVNlbGVjdEZpZWxkQ29tcG9uZW50LnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7OztBQUFBLGtEQUEwQjtBQXVCMUI7O0dBRUc7QUFDSCxNQUFhLDRCQUE2QixTQUFRLGVBQUssQ0FBQyxTQUF1QjtJQUU3RTs7OztPQUlHO0lBQ0gsWUFBWSxLQUFZO1FBQ3RCLEtBQUssQ0FBQyxLQUFLLENBQUMsQ0FBQztRQTRCZjs7OztXQUlHO1FBQ0ssYUFBUSxHQUFHLENBQUMsS0FBMkMsRUFBRSxFQUFFO1lBQ2pFLE1BQU0sYUFBYSxHQUFHLEtBQUssQ0FBQyxNQUFNLENBQUMsS0FBZSxDQUFDO1lBRW5ELElBQUksS0FBSyxDQUFDLE1BQU0sQ0FBQyxLQUFLLEVBQUU7Z0JBQ3RCLElBQUksQ0FBQyxLQUFLLENBQUMsYUFBYSxDQUFDLGFBQWEsQ0FBQyxDQUFDO2FBQ3pDO1FBQ0gsQ0FBQyxDQUFBO1FBdENDLElBQUksQ0FBQyxLQUFLLEdBQUcsRUFDWixDQUFDO0lBQ0osQ0FBQztJQUVEOztPQUVHO0lBQ0ksTUFBTTtRQUNYLE1BQU0sRUFBRSxLQUFLLEVBQUUsS0FBSyxFQUFFLFlBQVksRUFBRSxHQUFHLElBQUksQ0FBQyxLQUFLLENBQUM7UUFFbEQsSUFBSSxDQUFDLEtBQUssQ0FBQyxJQUFJLEVBQUU7WUFDZixPQUFPLElBQUksQ0FBQztTQUNiO1FBRUQsTUFBTSxPQUFPLEdBQUcsS0FBSyxDQUFDLE9BQU8sSUFBSSxFQUFFLENBQUM7UUFDcEMsTUFBTSxRQUFRLEdBQUcsS0FBZSxJQUFJLENBQUMsT0FBTyxDQUFDLE1BQU0sR0FBRyxDQUFDLENBQUMsQ0FBQyxDQUFDLE9BQU8sQ0FBQyxDQUFDLENBQUMsQ0FBQyxJQUFJLENBQUMsQ0FBQyxDQUFDLEVBQUUsQ0FBQyxDQUFDO1FBQ2hGLE1BQU0sUUFBUSxHQUFHLFlBQVksSUFBSSxLQUFLLENBQUMsUUFBUSxDQUFDO1FBRWhELE9BQU8sQ0FDTDtZQUNFLDBDQUFRLFFBQVEsRUFBRyxJQUFJLENBQUMsUUFBUSxFQUFHLEtBQUssRUFBRyxRQUFRLEVBQUcsU0FBUyxFQUFHLEtBQUssRUFBRyxRQUFRLEVBQUcsUUFBUSxJQUN6RixPQUFPLENBQUMsR0FBRyxDQUFDLENBQUMsTUFBTSxFQUFFLEVBQUUsQ0FBQywwQ0FBUSxHQUFHLEVBQUcsTUFBTSxDQUFDLElBQUksRUFBRyxLQUFLLEVBQUcsTUFBTSxDQUFDLElBQUksSUFBSyxNQUFNLENBQUMsSUFBSSxDQUFXLENBQUMsQ0FDOUYsQ0FDTCxDQUNQLENBQUM7SUFDSixDQUFDO0NBZUY7QUFqREQsb0VBaURDIn0=